import { render, staticRenderFns } from "./LevelRewardForm.vue?vue&type=template&id=52bd4dfa&"
import script from "./LevelRewardForm.vue?vue&type=script&lang=js&"
export * from "./LevelRewardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports